import { ComponentConfig } from "@measured/puck";

import { SupersetDashboardBlock, SupersetDashboardBlockProps } from "./SupersetDashboardBlock";

export type { SupersetDashboardBlockProps } from "./SupersetDashboardBlock";

export const SupersetDashboard: ComponentConfig<SupersetDashboardBlockProps> = {
    label: "Superset Dashboard",
    fields: {
        title: {
            type: "text",
            label: "Title",
        },
        dashboardUuid: {
            type: "text",
            label: "Dashboard UUID",
        },
        hideTitle: {
            type: "select",
            label: "Hide dashboard title",
            options: [
                { label: "Yes", value: true },
                { label: "No", value: false },
            ],
        },
        hideTab: {
            type: "select",
            label: "Hide dashboard tab",
            options: [
                { label: "Yes", value: true },
                { label: "No", value: false },
            ],
        },
        hideChartControls: {
            type: "select",
            label: "Hide chart controls",
            options: [
                { label: "Yes", value: true },
                { label: "No", value: false },
            ],
        },
        filtersVisible: {
            type: "select",
            label: "Show dashboard filters",
            options: [
                { label: "Yes", value: true },
                { label: "No", value: false },
            ],
        },
        hideWhenEmpty: {
            type: "select",
            label: "Hide when the dashboard has no data",
            options: [
                { label: "Yes", value: true },
                { label: "No", value: false },
            ],
        },
    },
    defaultProps: {
        title: "",
        dashboardUuid: "",
        hideTitle: true,
        hideTab: true,
        hideChartControls: false,
        filtersVisible: false,
        hideWhenEmpty: false,
    },
    render: ({ puck, ...props }) => <SupersetDashboardBlock {...props} isEditing={puck.isEditing} />,
};

export default SupersetDashboard;
